import { create } from "zustand";

interface CanvasHoverState {
  hoverNodeId: string | null;
  hoverCableId: string | null;
  setHoverNodeId(id: string | null): void;
  setHoverCableId(id: string | null): void;
}

export const useCanvasHover = create<CanvasHoverState>((set) => ({
  hoverNodeId: null,
  hoverCableId: null,
  setHoverNodeId: (id) => set({ hoverNodeId: id }),
  setHoverCableId: (id) => set({ hoverCableId: id }),
}));
